import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule  } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginAppComponent } from './login-app/login-app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import {ButtonModule} from 'primeng/button';
import { PrimeIcons } from 'primeng/api';
import {CardModule} from 'primeng/card';
import { TableModule } from 'primeng/table';
import { MessageService } from 'primeng/api';
// import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogModule,DialogService } from 'primeng/dynamicdialog';
import { DialogeComponent } from './dialoge/dialoge.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TimesheetPortalComponent } from './timesheet-portal/timesheet-portal.component';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { DatePipe } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { LoaderComponent } from './loader/loader.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { MessagesModule } from 'primeng/messages';
import { GetDeleteTimesheetComponent } from './get-delete-timesheet/get-delete-timesheet.component';
import { CalendarModule } from "primeng/calendar";
import { ToastModule } from 'primeng/toast';
import { QueryBuilderComponent } from './query-builder/query-builder/query-builder.component';

PrimeIcons
@NgModule({
  declarations: [
    AppComponent,
    LoginAppComponent,
    HeaderComponent,
    FooterComponent,
    DialogeComponent,
    TimesheetPortalComponent,
    LoaderComponent,
    GetDeleteTimesheetComponent,
    QueryBuilderComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    ButtonModule,
    CardModule,
    TableModule,
    ToastModule,
    DialogModule,
    DynamicDialogModule,
    ConfirmDialogModule,
    InputTextModule,
    DropdownModule,
    TooltipModule,
    InputTextareaModule,
    MessagesModule,
    ReactiveFormsModule,
    CalendarModule
],
  providers: [MessageService, DialogService,DatePipe,{provide: LocationStrategy, useClass: HashLocationStrategy}],
  bootstrap: [AppComponent],
 
  
  entryComponents: [DialogeComponent],

})
export class AppModule { }
